import React, { useRef, useState, useMemo } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useUpdateNotice } from "../../../../../api/inquiries/notice/use-notice";
import { useNoticeById } from "../../../../../api/inquiries/notice/use-notice-detail";
import TitlePage from "../../../../../components/section/TitlePage/Titlepage";
import Button from "../../../../../components/ui/Button/Button";
import Modal from "../../../../../components/ui/Modal/Modal";
import Editor from "../../../../../components/Editor";
import FieldBox from "../../../../../utils/Form/ui/FieldBox";

const NoticeEditPage = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const { data } = useNoticeById(id);
  const noticeData = data?.data;
  const [title, setTitle] = React.useState(noticeData?.title);
  const { mutate: updateNotice } = useUpdateNotice();
  const quillRef = useRef(null);
  const [isContentsEmpty, setIsContentsEmpty] = useState(false);

  const formEmpty = useMemo(() => {
    return title === "" || isContentsEmpty;
  }, [title, isContentsEmpty]);

  const onChangeTitle = (e) => {
    setTitle(e.target.value);
  };
  const handleSubmit = async () => {
    const payload = {
      title: title,
      contents: JSON.stringify(quillRef?.current?.getContents()),
      id: id,
    };
    await updateNotice(payload);
  };

  const handleBack = () => {
    navigate(`/bulletin-board/notice/${id}`);
  };

  const onTextChange = (content) => {
    setIsContentsEmpty(quillRef?.current?.getLength() === 1);
  };

  return (
    <>
      <div>
        <TitlePage title="공지사항 > 공지사항 상세 > 공지사항 수정" />
        <div className="mt-4">
          <form>
            <FieldBox label="제목">
              <input
                className="rounded-[4px] w-full text-[12px] p-2 focus:outline-none"
                placeholder="제목을 입력해주세요"
                name="title"
                value={title}
                onChange={onChangeTitle}
              />
            </FieldBox>
            <FieldBox isLast label="내용" padding="p-0">
              <Editor
                ref={quillRef}
                defaultValue={JSON.parse(noticeData?.contents)}
                onTextChange={onTextChange}
              />
            </FieldBox>
            <div className="flex justify-end mt-4">
              <Modal
                description="입력을 취소하시겠습니까? 입력한 정보는 저장되지 않습니다."
                onSubmit={handleBack}
              >
                <Button text="입력취소" />
              </Modal>
              <Modal
                description="입력을 취소하시겠습니까? 입력한 정보는 저장되지 않습니다."
                onSubmit={handleSubmit}
              >
                <Button
                  onClick={(e) => e.preventDefault()}
                  type="submit"
                  primary
                  text="등록완료"
                  isDisabled={formEmpty}
                />
              </Modal>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default NoticeEditPage;
